import React from 'react';
import { useSettingsTimeZone } from 'hooks';
import moment from 'moment-timezone';
import { SlotLabelContentArg } from '@fullcalendar/core';
import { createStyles, makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaw } from '@fortawesome/pro-light-svg-icons';
import { getStaffSlotsPetsCountByDate } from 'components/StaffSchedule/utils/StaffScheduleUtils';
import Staff from 'model/Staff';

export interface ScheduleTypeCalendarSlotLabelProps extends SlotLabelContentArg {
    staffs: Array<Staff>;
}

const useStyles = makeStyles(() =>
    createStyles({
        date: {
            margin: 0,
            fontSize: 14,
            fontWeight: 500,
            fontFamily: 'Poppins'
        },
        petsCount: {
            'fontSize': 12,
            'lineHeight': 1,
            'fontWeight': 400,
            'margin': '4px 0px 0px',
            'fontFamily': 'Poppins',
            'color': '#7A7A7A',

            '& svg': {
                marginRight: 4
            }
        }
    })
);

export const ScheduleTypeCalendarSlotLabel: React.FC<ScheduleTypeCalendarSlotLabelProps> = props => {
    const classes = useStyles();
    const timeZone = useSettingsTimeZone();

    const momentDate = moment(props.date).tz(timeZone);

    const petsCount = React.useMemo(() => {
        return props.staffs.reduce((acc, staff) => {
            return acc + getStaffSlotsPetsCountByDate(staff.slots, momentDate);
        }, 0);
    }, [props.staffs, momentDate]);

    return (
        <>
            <p className={classes.date}>{moment(props.date).tz(timeZone).format('ddd, D MMM')}</p>
            <p className={classes.petsCount}>
                <FontAwesomeIcon icon={faPaw} />
                {petsCount} pets
            </p>
        </>
    );
};
